// Copyright (c) Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

import { Component } from '@angular/core';

@Component({
  selector: 'app-migrate-modules-to-standalone',
  templateUrl: './migrate-modules-to-standalone.component.html',
  styleUrls: ['./migrate-modules-to-standalone.component.css', './../app.component.css'],
  standalone: true,
  imports: [],
})
export class MigrateModulesToStandaloneComponent {
  constructor() {}
}
